import { CEPlanBase } from './ce-plan-base'


export class CEPlan extends CEPlanBase {

}